
import BaseButton from '@/components/base/BaseButton.vue'

export default {
  components: { BaseButton },
  data() {
    return {
      url: "https://trebel.io/wallet?source=streaks",
      qr: null,
      QRCodeModuleLoaded: false
    }
  },
  mounted() {
    if(this.$device.isDesktop) {
      this.getQRCode()
    }
  },
  methods: {
    async getQRCode() {
      const options = {
        width: 300,
        height: 300,
        errorCorrectionLevel: 'L',
        type: 'image/webp',
        rendererOpts: {
          quality: 1
        }
      }
      /* global QRCode */
      this.qr = await QRCode.toDataURL(
        this.url,
        options
      )
    },
    directToPage() {
      window.location = this.url
    }
  },
  head() {
    return {
      script: [
        {
          hid: 'QRCode',
          src:
            'https://jojotoo-static.oss-cn-shanghai.aliyuncs.com/resources/script/qrcode.min.js',
          defer: true,
          callback: () => {
            this.QRCodeModuleLoaded = true
          }
        }
      ]
    }
  }
}

